import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQuery } from '../../utils/baseQuery';
import { getAdditionalTags } from './queries/get-additional-tags.query';
import {
  getFileCategories,
  getJobPositions,
  getJobPositionsIdAndTitle,
  getSkillsQuery,
} from './queries';
import { ReducerPaths } from '../../constants/reducerPaths';
import { getPublicJobPositions } from './queries/get-public-job-positions.query';

export const formInfoApi = createApi({
  reducerPath: ReducerPaths.FORM_INFO,
  baseQuery,
  endpoints: (builder) => ({
    getJobPositions: getJobPositions(builder),
    getSkills: getSkillsQuery(builder),
    getFileCategories: getFileCategories(builder),
    getAdditionalTags: getAdditionalTags(builder),
    getJobPositionsIdAndTitle: getJobPositionsIdAndTitle(builder),
    getPublicJobPositions: getPublicJobPositions(builder),
  }),
  tagTypes: ['JobPositions'],
});

export const {
  useGetJobPositionsQuery,
  useGetSkillsQuery,
  useGetFileCategoriesQuery,
  useGetAdditionalTagsQuery,
  useGetJobPositionsIdAndTitleQuery,
  useGetPublicJobPositionsQuery,
} = formInfoApi;
